import React from "react";
import { useIntl } from "react-intl";
import PropTypes from 'prop-types';

import { reportsService } from "../../../services/reports-service";

import { DropdownSearchHelpTagInput } from "../../common/form-controls/dropdown-search-help-input.jsx";

const getMatrices = (params, signal) => {
    return reportsService.getMatrixSearchHelp(params, signal);
};

const MatrixIdsInput = ({ tags, setTags, onTagClick = () => { }, }) => {
    const intl = useIntl();
    const label = intl.formatMessage({ id: "report-parameters.matrix-label" });

    return (
        <DropdownSearchHelpTagInput
            tags={tags}
            setTags={setTags}
            getData={getMatrices}
            label={label}
            onTagClick={onTagClick}
        />
    );
};

MatrixIdsInput.propTypes = {
    tags: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string,
        text: PropTypes.string
    })),
    setTags: PropTypes.func, 
    onTagClick: PropTypes.func
};

export default MatrixIdsInput;
